var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgArrowRight = function SvgArrowRight(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.29279 12.7068C6.10532 12.5191 6 12.2645 6 11.999C6 11.7335 6.10532 11.4788 6.29279 11.2911L9.58579 7.99395L6.29279 4.69683C6.11063 4.50799 6.00983 4.25508 6.01211 3.99255C6.01439 3.73003 6.11956 3.4789 6.30497 3.29326C6.49038 3.10762 6.74119 3.00232 7.00339 3.00004C7.26558 2.99776 7.51818 3.09868 7.70679 3.28106L11.7068 7.28607C11.8943 7.47383 11.9996 7.72846 11.9996 7.99396C11.9996 8.25945 11.8943 8.51408 11.7068 8.70184L7.70679 12.7068C7.51926 12.8946 7.26495 13 6.99979 13C6.73462 13 6.48031 12.8946 6.29279 12.7068Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgArrowRight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "arrow-right.22d25775da899a867fc9261284e66eaf.svg";